<style scoped lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/material/inventory/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('wuliaomingcheng')">
            <!-- 跨组件 - 物料信息 -->
            <!--						<yi_cross_select multiple :component="'web_base_matter_list'" :min="1"-->
            <!--							:ids.sync="yt.conditions.materialIds"></yi_cross_select>-->
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIds"> </yi_data_select>
          </el-form-item>
          <!-- 产品分类(数据来源: 客户字典中code="GYLXCPFL"的所有字典值) -->
          <el-form-item :label="$t('chanpinfenlei')">
            <el-select filterable :clearable="true" v-model="yt.conditions.productType">
              <el-option v-for="(item, index) in productType" :key="index" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('cangkumingcheng')">
            <!-- 跨组件 - 仓库/库区/库位 warehouseIds的值说明:
						1.一次最多会传3个值到接口
						2.如果是3个值,那么第0位是仓库id(1开头),第二位是库区id(2开头),第三位是库位id(3开头),
						3.如果是2个值,那么第0位是库区id(2开头),第1位是库位id(3开头)
						4.如果是1个值,那么第0位是库位的值(3开头),后端收到请求后需截取掉第一位才能得到真正的id
						5.yt.conditions.test 用于clear()清除使用,无需理会;
						-->
            <yi_data_select :type="'warehouse'" :ids.sync="yt.conditions.warehouseIds"> </yi_data_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #buttonsL>
        <el-button size="mini" @click="show = !show" type="primary">
          {{ $t('kucunchushihua') }}
        </el-button>
      </template>
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body>
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('gongyingshangbianma')" required>
            <el-input v-model="yt.editObj.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('gongyingshangmingcheng')" required>
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('gongyingshangdizhi')" required>
            <el-input v-model="yt.editObj.address"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lianxiren')">
            <el-input v-model="yt.editObj.contacts"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lianxifangshi')">
            <el-input v-model="yt.editObj.contactsInfo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('youxiang')">
            <el-input v-model="yt.editObj.email"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/supplier/create')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('gongyingshangbianma')" required>
            <el-input v-model="yt.editObj.code" disabled></el-input>
          </el-form-item>
          <el-form-item :label="$t('gongyingshangmingcheng')" required>
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('gongyingshangdizhi')" required>
            <el-input v-model="yt.editObj.address"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lianxiren')">
            <el-input v-model="yt.editObj.contacts"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lianxifangshi')">
            <el-input v-model="yt.editObj.contactsInfo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('youxiang')">
            <el-input v-model="yt.editObj.email"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/supplier/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
    <import_excel :show.sync="show" />
  </div>
</template>
<script type="text/javascript">
import import_excel from '@@/pages/web/wms/material_inventory/import_excel';
export default {
  components: {
    import_excel
  },
  name: 'wms_material_inventory_list',
  data() {
    return {
      show: false,
      productType: [],
      warehouseList: [],
      colorNoEnable: false,
      columns: [
        {
          label: 'wuliaobianma',
          prop: 'material.code',
          width: 150
        },
        {
          label: 'wuliaomingcheng',
          prop: 'material.name',
          width: 150
        },
        {
          label: 'sehao',
          prop: 'colorNo',
          type: 'dictionary',
          key: 'CUSTOMER_MATERIAL_COLOR_NO',
          width: 130,
          show: false
        },
        {
          label: 'chanpinfenlei',
          prop: 'material.value',
          type: 'dictionary',
          width: 150,
          key: 'GYLXCPFL'
        },
        {
          label: 'cangkubianma',
          prop: 'warehouse.code',
          width: 150
        },
        {
          label: 'cangkumingcheng',
          prop: 'warehouse.name',
          width: 150
        },
        {
          label: 'cangkudizhi',
          prop: 'warehouse.address',
          width: 150
        },
        {
          label: 'kuqubianma',
          prop: 'warehouseArea.code',
          width: 150
        },
        {
          label: 'kuqumingcheng',
          prop: 'warehouseArea.name',
          width: 150
        },
        {
          label: 'kuweibianma',
          prop: 'warehouseLocation.code',
          width: 150
        },
        {
          label: 'kuweimingcheng',
          prop: 'warehouseLocation.name',
          width: 150,
          width: 150
        },
        {
          label: 'danwei',
          prop: 'unit',
          type: 'dictionary',
          key: 'UNIT_CONVERSION_TYPE'
          // width: 150,
        },
        {
          label: 'zongshu',
          prop: 'total'
        },
        {
          label: 'keyongshu',
          prop: 'available',
          width: 150
        },
        {
          label: 'yifenpeishu',
          prop: 'allocated',
          width: 150
        },
        {
          label: 'gongyingshangmingcheng',
          prop: 'supplier.name',
          width: 150
        },
        {
          label: 'kehumingcheng',
          prop: 'wmsCustomer.name',
          width: 150
        },
        {
          label: 'wuliaopicihao',
          prop: 'materialBatchNo',
          width: 150
        },
        {
          label: 'shengchanpicihao',
          prop: 'productionBatchNo',
          width: 150
        },
        {
          label: 'shengchangongdanhao',
          prop: 'woNo',
          width: 150
        },
        {
          label: 'rukushijian',
          prop: 'storageTime',
          type: 'time',
          width: 150
        }
      ]
    };
  },

  created() {
    this.getProductionConfig();
    setTimeout(() => {
      this.yt.get(1);
      this.getProductType();
      this.utils.event_hub.$on('MATERIAL_INVENTORY_LIST', () => {
        this.yt.get();
      });
    }, 300);
  },
  destroyed() {
    this.utils.event_hub.$off('MATERIAL_INVENTORY_LIST');
  },

  methods: {
    // 查询生产配置-启用产品色号管理
    getProductionConfig() {
      this.http.get('/web/production/config/list?type=26&status=1').then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.colorNoEnable = true;
        }
        if (this.colorNoEnable) {
          this.showColumn('sehao');
        }
      });
    },
    // 显示指定列
    showColumn(label) {
      for (let i = 0; i < this.columns.length; i++) {
        const c = this.columns[i];
        if (c.label === label) {
          c.show = true;
          break;
        }
      }
    },
    // 请求查询客户数据字典中的产品分类
    async getProductType() {
      let response = await this.http.get('/web/config/customer/dictionary/item/getDictionaryByTypeCode', {
        params: {
          code: 'GYLXCPFL'
        }
      });
      this.productType = response.data;
      console.log(this.productType);
    },

    exportExcel() {
      let params = JSON.parse(JSON.stringify(this.yt.conditions));
      if (params.warehouseIds) {
        let warehouseId = params.warehouseIds[0] + '';
        params.warehouseIds = [];
        let fistChar = warehouseId.substring(0, 1);
        let paramChar = warehouseId.substring(1, warehouseId.length);
        if (fistChar === '1') {
          params.warehouseIds[0] = paramChar;
        } else if (fistChar === '2') {
          params.warehouseAreaId = paramChar;
        } else {
          params.warehouseLocationId = paramChar;
        }
      }
      console.log(params);
      return this.http
        .get('/web/report/export/wms_material_inventory_export', {
          params
        })
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    }
  }
};
</script>
